'use strict';
const angular = require('angular');

/*@ngInject*/
export function ClientErrorsService($resource) {
  return $resource('/api/client-errors/:id', {
    name: '@_id'
  },{
  });
}


export default angular.module('conduuApp.ClientErrorsService', [])
  .factory('ClientErrorsService', ClientErrorsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/client-errors/client-errors.service.js